<template>
  <kf-button
    class="go-to-top-button"
    :class="[{ 'go-to-top-button--show': showButton }]"
    @click="scrollToTop()"
  >
    <ArrowGoToTop
      class="go-to-top-button__icon icon"
    />
  </kf-button>
</template>

<script>
export default {
  name: 'GoToTopButton',
  components: {
    KfButton: () => import(/* webpackChunkName: "main" */ '@/components/base/button/Button.vue'),
    ArrowGoToTop: () => import(/* webpackChunkName: "main"*/ '@/components/svg/ArrowGoToTop.vue'),
  },
  data() {
    return {
      showButton: false,
      scrollDebounceTimer: null,
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScrollEvent);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScrollEvent);
  },
  methods: {
    handleScrollEvent() {
      clearTimeout(this.scrollDebounceTimer);
      this.scrollDebounceTimer = setTimeout(() => {
        this.showButton = window.scrollY >= 100;
      }, 200);
    },
    scrollToTop() {
      const appElement = document.querySelector('#app');
      if (appElement) {
        appElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="postcss">
.go-to-top-button {
  @apply fixed right-0 bottom-0 z-50 p-3 mr-10 mb-8 rounded-full bg-white shadow opacity-0 transform translate-y-36;
  transition-property: transform, opacity;
  transition-duration: 0s, 0.2s;
  transition-delay: 0.2s, 0s;
  transition-timing-function: ease-out, ease-out;

  &__icon {
    @apply w-5 h-5 !important;
    @apply ml-auto mr-auto;
  }

  &--show {
    @apply opacity-100 translate-y-0;
    transition-delay: 0s, 0s;
  }
}
</style>
